import type { GenerationJobRow } from "@/types/workspace"

export type CameraLevel = "system" | "company" | "project"

export type CameraDemoStatus = "idle" | "queued" | "processing" | "failed"

export type CameraPresetRow = {
  id: number
  project_id: number | null
  company_id: number | null
  name: string
  description: string | null
  narrative_purpose: string | null
  when_to_apply: string | null
  system_prompt_fragment: string | null
  tags: string[]
  favorite: boolean
  builtin: boolean
  level: CameraLevel
  hidden: boolean
  excluded: boolean
  destroyable: boolean
  destroyable_reason: string | null
  demo_status: CameraDemoStatus | null
  demo_error: string | null
  demo_generated_with: string | null
  demo_video_url: string | null
  demo_poster_url: string | null
}

export type CameraContext = "project" | "studio" | "company"

export const CAMERA_PRESET_DEMO_JOB_KIND = "camera_preset_demo"

export function cameraDemoJob(jobs: GenerationJobRow[], presetId: number): GenerationJobRow | null {
  const id = Number(presetId)
  return (
    jobs.find(
      (j) =>
        j.job_kind === CAMERA_PRESET_DEMO_JOB_KIND &&
        (j.status === "queued" || j.status === "processing") &&
        ((j.subject_type === "CameraPreset" && Number(j.subject_id) === id) ||
          (j.subject_type == null && Number(j.subject_id) === id)),
    ) ?? null
  )
}

export function cameraDemoJobBusy(jobs: GenerationJobRow[], presetId: number): boolean {
  return cameraDemoJob(jobs, presetId) != null
}

export function cameraDemoBusy(
  preset: Pick<CameraPresetRow, "id" | "demo_status">,
  jobs?: GenerationJobRow[],
): boolean {
  if (jobs && cameraDemoJobBusy(jobs, preset.id)) return true
  return preset.demo_status === "queued" || preset.demo_status === "processing"
}
